export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14597.b16e5f94.jpg";